package ru.villawonka.app.common.extensions

fun Int.priceFormat(): String = toString().priceFormat()